import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthRedirectService } from './auth-redirect.service';

/**
 * Protects the authenticated area (LayoutComponent and its children).
 * Unauthenticated users are sent to /login with the originally requested
 * URL preserved so they land back on it after a successful login.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private authRedirectService: AuthRedirectService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAuth(state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAuth(state);
  }

  private checkAuth(state: RouterStateSnapshot): boolean | UrlTree {
    if (this.authRedirectService.isAuthenticated()) {
      return true;
    }
    this.authRedirectService.setRedirectUrl(state.url);
    return this.router.createUrlTree(['/login']);
  }
}